export const COMMON_ASSETS = {
  nav: {
    home: {
      path: 'assets/nav/home.png',
      width: 24,
      height: 24
    },
    team: {
      path: 'assets/nav/team.png', 
      width: 24,
      height: 24
    },
    characters: {
      path: 'assets/nav/characters.png',
      width: 24,
      height: 24
    },
    character: {
      path: 'assets/nav/character.png',
      width: 24,
      height: 24
    },
    loadout: {
      path: 'assets/nav/loadout.png',
      width: 24,
      height: 24
    },
    progress: {
      path: 'assets/nav/progress.png',
      width: 24,
      height: 24
    },
    banners: {
      path: 'assets/nav/banners.png',
      width: 24,
      height: 24
    },
    daily: {
      path: 'assets/nav/daily.png',
      width: 24,
      height: 24
    },
    chat: {
      path: 'assets/nav/chat.png',
      width: 24,
      height: 24
    },
    missions: {
      path: 'assets/nav/missions.png',
      width: 24,
      height: 24
    },
    minigame: {
      path: 'assets/nav/minigame.png',
      width: 24,
      height: 24
    },
    ranking: {
      path: 'assets/nav/ranking.png',
      width: 24,
      height: 24
    },
    shop: {
      path: 'assets/nav/shop.png',
      width: 24,
      height: 24
    },
    friends: {
      path: 'assets/nav/friends.png',
      width: 24,
      height: 24
    },
    settings: {
      path: 'assets/nav/settings.png',
      width: 24,
      height: 24
    }
  }
};
